const LogoutErrorComponent = () => {
  return (
    <div className="error-component">
      <div className="main-site-content container">
        <div className="user-form-wrap">
          <div className="page-head">
            <img
              alt=""
              src="https://image.flaticon.com/icons/svg/148/148766.svg"
              className="response-svg"
            />
            <h1>Authorization Error</h1>
            <p className="sub-text">
              There was an error. Please clear your cookies and try again.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoutErrorComponent;
